module.exports = __webpack_public_path__ + "static/media/Inter_18pt-Bold.7ef6f6d6.ttf";